// Use a TypeScript version of gatsby-node.js.
module.exports = require('./src/gatsby-api/browser.ts');
